import { useEffect, useState } from "react";
import { fetchCpfHash } from "../apis/user";

export function useCpfHash(
  token: string | undefined,
  authenticated: boolean | undefined
): string | undefined {
  const [hashUserCpf, setHashUserCpf] = useState<string | undefined>(undefined);

  useEffect(() => {
    let isActive = true;

    if (!authenticated || !token) {
      setHashUserCpf(undefined);
      return;
    }

    const load = async () => {
      try {
        const hash = await fetchCpfHash(token);
        if (isActive) setHashUserCpf(hash ?? undefined);
      } catch {
        if (isActive) setHashUserCpf(undefined);
      }
    };

    load();

    return () => {
      isActive = false;
    };
  }, [authenticated, token]);

  return hashUserCpf;
}
